import { ReactElement } from 'react'

import { ExportMenu } from '@features/expertReports'

import { useDownloadExpertBalanceSheetExport } from '../../hooks/useDownloadExpertBalanceSheetExport'

export const ExpertBalanceSheetExportMenu = (): ReactElement => {
  const { downloadExport, isExporting } = useDownloadExpertBalanceSheetExport()

  return <ExportMenu isExporting={isExporting} onSelectFormat={downloadExport} />
}
